<template>
  <div class="container">
    <div class="col-lg-6 col-md-6 ml-auto mr-auto">
      <card class="card-login card-white p-5 text-left">
        <div>
          <div class="row text-center pb-3">
            <div class="col">
              <img width="150" src="img/edp_logo.png" alt="" />
            </div>
          </div>
          <base-input
            v-validate="'required|email'"
            name="email"
            v-model="model.email"
            placeholder="Email"
            addon-left-icon="tim-icons icon-email-85"
          >
          </base-input>

          <base-input
            v-validate="'required|min:5'"
            name="password"
            v-model="model.password"
            type="password"
            placeholder="Password"
            addon-left-icon="tim-icons icon-lock-circle"
          >
          </base-input>
          <p class="mensagemErro" v-show="mensagemErro">
            Os dados que introduziu estão incorretos.
          </p>
        </div>

        <div slot="footer" class="text-center">
          <base-button
            style="width: 100%;"
            @click="login"
            class="mb-3 bg_edp_roxo"
            size="lg"
            simple
          >
            Entrar
          </base-button>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import { Card, BaseInput } from "@/components/index";
  import api from "@/api/index";

  export default {
    components: {
      Card,
      BaseInput,
    },
    data() {
      return {
        mensagemErro: false,
        model: {
          email: "",
          password: "",
          subscribe: true,
        },
      };
    },
    methods: {
      async login() {
        if (this.model.email == "" || this.model.password == "") {
          return;
        }
        let res = await api.login(this.model);
        if (res) {
          if (Object.values(res).length > 0) {
            localStorage.setItem("active-session-niu", res[0].user_id);
            if (res[0].grupo == "0") {
              if (res[0].nivel == "1") {
                this.$router.push("/classificacao");
              } else if (res[0].nivel == "2") {
                this.$router.push("/promotor");
              } else {
                this.$router.push("/dashboard");
              }
            } else {
              if (res[0].nivel == "1") {
                this.$router.push("/classificacao");
              } else if (res[0].nivel == "2") {
                this.$router.push("/promotor");
              } else {
                this.$router.push("/atividades");
              }
            }
          } else {
            this.mensagemErro = true;
          }
        } else {
          this.mensagemErro = true;
        }
      },
    },
  };
</script>
<style>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
